<template>
  <div class="add-work">
    <field
      v-model="valueType"
      is-link
      readonly
      label="课程"
      placeholder="课程类型"
      @click="showPicker2 = true"
    />
    <popup v-model="showPicker2" round position="bottom">
      <picker
        :columns="typeList.map(x => x.title)"
        show-toolbar
        @cancel="showPicker2 = false"
        @confirm="onConfirmType"
      />
    </popup>
    <field
      v-model="valueName"
      is-link
      readonly
      label="名字"
      placeholder="选择名字"
      @click="showPicker = true"
    />
    <popup v-model="showPicker" round position="bottom">
      <picker
        :columns="studentList.map(x => x.name)"
        show-toolbar
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </popup>
    <div class="box">
      <div v-if="selectState === 0" class="select-box">
        <div class="select-btn" @click="selectState = 1">上传图片</div>
        <div class="select-btn" @click="selectState = 2">上传视频</div>
      </div>
      <div v-if="selectState === 1" class="img-box">
        <div class="title-text">
          <div class="text"> 
            <div @click="showSelect = true" ref="selectBtn">上传图片</div>
            <div class="select-btn-min-box" v-show="showSelect">
              <div @click="selectState = 1" :class="{ selectState: selectState === 1 }" class="select-btn-min">上传图片</div>
              <div @click="selectState = 2" :class="{ selectState: selectState === 2 }" class="select-btn-min bottom-top-01rem">上传视频</div>
            </div>
          </div>
          <div class="count-splice"> {{imageList.length}}/{{counter}} </div>
        </div>
        <uploader v-model="imageList" preview-size="calc(33.33vw - 10.7px)" multiple :max-count="counter"  accept="image/*" class="img-select" :before-delete="beforeDelete" :after-read="afterRead"/>
      </div>
      <div v-if="selectState === 2" class="video-box">
        <div class="title-text">
          <div class="text"> 
            <div @click="showSelect = true" ref="selectBtn">上传视频</div>
            <div class="select-btn-min-box" v-show="showSelect">
              <div @click="selectState = 1" :class="{ selectState: selectState === 1 }" class="select-btn-min">上传图片</div>
              <div @click="selectState = 2" :class="{ selectState: selectState === 2 }" class="select-btn-min bottom-top-01rem">上传视频</div>
            </div>
          </div>
          <div class="count-splice"> {{videoList.length}}/{{videoCounter}} </div>
        </div>
        <uploader v-model="videoList" :preview-size="['calc(100vw - 16px)', '4rem']" class="img-select" image-fit="scale-down" multiple :max-count="videoCounter"  accept="video/*" :before-delete="beforeDelete" :after-read="afterRead"/>
      </div>
    </div>
    <textarea-box :title="'内容'" :placeholder="'输入内容'" v-model="content"/>
    <div class="btn" @click="sub"> 提&nbsp;交 </div>
  </div>
</template>

<script>
  import { addArticle, getArticleCategoryList } from '@api/article'
  import { UPLOAD_IMG } from '@api/uploader'
  import { getUserStudent } from '@api/user'

  import { getFlieType } from '@common'
  import { Picker, Field, Popup, Uploader } from "vant"

  import TextareaBox from '@components/common/textBox/textareaBox/TextareaBox'

  export default {
    name: 'AddWork',
    components: {
      Picker,
      Field,
      Popup,
      Uploader,
      TextareaBox
    },
    data() {
      return {
        studentList: [],
        valueName: '',
        showPicker: false,
        studentCurrIndex: 0,
        typeList: [],
        valueType: "",
        showPicker2: false,
        typeCurrIndex: 0,
        selectState: 1,
        catchCount: 0, //图片请求失败次数
        showSelect: false,
        content: '',

        imageList: [],
        imageUrlList: [],
        videoList: [],
        videoUrlList: [],
        uploadAwait: false, //上传等待
        counter: 6,
        videoCounter: 1,
      }
    },
    mounted() {
      this.documentTrigger();
      getUserStudent(this.$route.params.uid).then(res => {
        let resList = res.data.student;
        for (let item of resList) {
          this.studentList.push({
            name: item.name,
            id: item.Id
          });
        }
      })
      getArticleCategoryList(1, this.$route.params.uid).then(res => {
        let resList = res.data.data;

        for (let item of resList) {
          this.typeList.push({
            title: item.title,
            cid: item.id,
          });
        }
      })
    },
    methods: {
      sub() { //提交
        if (!this.valueType) {
          return this.$Message.success('请选择课程');
        }else if (!this.valueName) {
          return this.$Message.success('请选择学生');
        }

        let files = [];
        if (!this.selectState) {
          return this.$Message.success('请选择上传的文件');
        }else if (this.selectState === 1) {
          if (!this.imageList.length) {
            return this.$Message.success('至少选择一张图片');
          }else if (this.imageList.length !== this.imageUrlList.length){
            return this.$Message.success('图片未上传!');
          }else {
            files = this.imageUrlList;
          }
        }else if (this.selectState === 2) {
          if (!this.imageList.length) {
            return this.$Message.success('请选择视频');
          }else if (this.videoList.length !== this.videoUrlList.length){
            return this.$Message.success('视频未上传!');
          }else {
            files = this.videoUrlList;
          }
        }

        let form = {
          content: this.content,
          cid: this.typeList[this.typeCurrIndex].cid,
          slider_image: files,
          sid: Number(this.studentList[this.studentCurrIndex].id),
        }
        if (!this.uploadAwait) {
          addArticle(form).then(res => {
            if (res.status === 200) {
              this.$Message.success('作品添加成功');
              this.$router.go(-1);
            }
          }).catch(err => {
            this.$Message.success(err.msg);
          })
        }
      },
      onConfirm(value, index) { //选择学生
        this.valueName = value;
        this.showPicker = false;
        this.studentCurrIndex = index;
      },
      onConfirmType(value, index) { //选择类型
        this.valueType = value;
        this.showPicker2 = false;
        this.typeCurrIndex = index;
      },
      afterRead(file, index) { //选择（图片/视频）
        if (!Array.isArray(file)) {
          file = [file];
        }
        for (let i = 0; i < file.length; i++) {
          let fileUrl = file[i].file;
          let formData = new FormData();
          formData.append('file', fileUrl);
          this.uploadFile(formData, fileUrl, index.index+i)
        }
      },
      beforeDelete(file, index) { //移除（图片/视频）
        let indexT = index.index;
        if (getFlieType(file.file.name) === 'video') {
          this.videoList.splice(0, this.videoList.length);
          if (this.videoUrlList.length > indexT){
            this.videoUrlList = [];
          }
        }else if (getFlieType(file.file.name) === 'image') {
          this.imageList.splice(indexT, 1);
          if ((this.imageUrlList.length-this.catchCount) > indexT) {
            this.imageUrlList.splice(indexT, 1);
          }
        }
      },
      uploadFile(formData, file, index) { //上传文件
        if (getFlieType(file.name) === 'image') {
          this.imageList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/leaf.jpeg';
          this.imageList[index].status = 'uploading';
          this.imageList[index].message = '上传中...';
        }else if (getFlieType(file.name) === 'video') {
          this.videoList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/leaf.jpeg';
          this.videoList[index].status = 'uploading';
          this.videoList[index].message = '上传中...';
        }
        let timer = setInterval(() => {
          if (!this.uploadAwait) {
            clearInterval(timer);
            this.uploadAwait = true;
            UPLOAD_IMG(formData).then(res => {
              let result = res.data.url;
              if (getFlieType(file.name) === 'image') {
                this.imageUrlList.push(result);
                delete this.imageList[index].url;
                this.imageList[index].status = '';
                this.imageList[index].message = '';
              }else if (getFlieType(file.name) === 'video') {
                this.videoUrlList.push(result);
                delete this.videoList[index].url;
                this.videoList[index].status = '';
                this.videoList[index].message = '';
              }
            }).catch(err => {
              if (getFlieType(file.name) === 'image') {
                this.catchCount++;
                this.imageList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/tree.jpeg';
                this.imageList[index].status = 'failed';
                this.imageList[index].message = '上传失败';
              }else if (getFlieType(file.name) === 'video') {
                this.videoList[index].url = 'https://cdn.jsdelivr.net/npm/@vant/assets/tree.jpeg';
                this.videoList[index].status = 'failed';
                this.videoList[index].message = '上传失败';
              }
              this.$Message.success(err.msg);
            }).finally(() => {
              this.uploadAwait = false;
            })          
          }
        }, 50);
      },
      onShowSelect(e) {
        if (e.target !== this.$refs.selectBtn) {
          this.showSelect = false;
        }
      },
      documentTrigger() {
        this.$el.addEventListener('click', (e) => {
          this.onShowSelect(e);
        });
      }
    },
  }
</script>

<style scoped>
  .add-work {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #f5f5f5;
  }
    .box{
      padding-top: 0.2rem;
      width: 100%;
    }
      .img-select {
        padding-left: 8px;
      }
        .title-text {
          display: flex;
          padding: 0 0.2rem 0.2rem;
          justify-content: space-between;
        }
          .text {
            color: #848a90;
            position: relative;
            width: 2rem;
            text-align: center;
          }
            .select-btn-min-box {
              position: absolute;
              z-index: 200;
              background-color: white;
              width: 100%;
              text-align: center;
              border-radius: 0.1rem;
              overflow: hidden;
            }
              .select-btn-min {
                padding-top: 0.1rem;
              }
              .selectState {
                background: #b3cbf5;
                color: white;
              }
              .bottom-top-01rem {
                padding-bottom: 0.1rem;
              }
          .count-splice {
            color: #dfaae2;
          }
      .select-box {
        padding: 0 0.2rem;
      }
        .select-btn {
          width: 60%;
          margin: 0 20%;
          text-align: center;
          height: 0.6rem;
          line-height: 0.6rem;
          background-color: #99badc;
          color: white;
          border-radius: 0.2rem;
          margin-top: 0.2rem;
        }
    .btn {
      width: 80vw;
      margin: 0.5rem 10vw;
      height: 0.8rem;
      border-radius: 0.2rem;
      background-color: #2980f7;
      text-align: center;
      line-height: 0.8rem;
      color: aliceblue;
    }
</style>